<template>
    <div>
        <div class="col-md-8 animated slideInLeft">
            <div class="titulo-top">
                <div class="row ">
                    <div class="col-sm-12 bg-negro">
                        <!-- <h1 v-if=" (typeof sectionID !== 'undefined' && sectionID )">{{ ( sectionID !== 'ott_vod' ) && (sectionID!=='ott_summit') ? descripcion : (sectionID == 'ott_vod') ? 'OTT VOD' : 'OTT SUMMIT' }}</h1>
                        <a v-if="(sectionID =='ott_vod')"  data-toggle="collapse" href="#CategoriasOTT"><i class="fa fa-angle-down" ></i></a> -->
                        <h1 v-if="currSectionName">{{ currSectionName.toUpperCase() }}</h1>
                    </div>
                </div>

                <div id="CategoriasOTT" class="panel-collapse collapse">
                    <ul class="list-group" align="center">
                        <a @click="getCompanyOTT(0)" href="#empresas" data-toggle="tab">
                            <li class="list-group-item" >Todas las Empresas</li>
                        </a>
                        <a @click="getCompanyOTT(index)"  v-for="(cat,index) in categoriasOtt" if="(typeof  categoriasOtt!== 'undefined' )" href="#empresas" data-toggle="tab">
                            <li class="list-group-item" v-html="cat.Descripcion" ></li>
                        </a>
                    </ul>
                </div>

            </div>

            <div class="tab-top">
                <div class="tab-content scroll-not">
                    <!-- Tab Contactos -->
                    <div id="contactos" class="tab-pane fade in active">
                        <div class="noticia" v-for="(tmp,key) in contacts" v-if=" contacts  && (typeof contacts !== 'undefined' )" >
                            <div class="row">
                                <div class="col-md-2" align="center">
                                    <div class="imagen-tab-ne">
                                        <router-link  :to="'/contacto/'+tmp.permalink_contacto" class="color" >
                                            <!-- <div class="feat-image" v-if="tmp.Images!==null && tmp.Images.startsWith('http')" :style="{ 'background-image': 'url(' + tmp.Images + ')' }"></div>
                                            <div class="feat-image" v-else-if="tmp.Images!==null" :style="{ 'background-image': 'url(\'https://images.produ.com/ww/'+ getVerticalContact(tmp.Images) + '\')' }"  ></div>
                                            <div  v-if="tmp.Images==null">
                                                <img  class="feat-image" src="../../assets/images/avatar2.png">
                                            </div> -->
                                            <div class="feat-image" :style="{ 'background-image': 'url('+ getImageUrl(tmp.Images) +')' }" ></div>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <div class="info-tabs">
                                        <router-link  :to="'/contacto/'+tmp.permalink_contacto" class="color" >
                                            <h3 v-html="tmp.FirstName+' '+tmp.LastName" ></h3>
                                        </router-link>
                                        <router-link  :to="'/empresa/'+tmp.permalink_empresa" class="color" >
                                            <h3 v-html="tmp.Title" ></h3>
                                        </router-link>
                                        <router-link  :to="'/empresa/'+tmp.permalink_empresa" class="color" >
                                            <h3 v-html="tmp.CompanyName" ></h3>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Paginacion English news -->
                        <div align="center">
                            <h5 class="msg" v-if="contacts.length==0">No existen Contactos</h5>
                            <div v-if="total_pagesCont && (typeof total_pagesCont=='number') && total_pagesCont > 1">
                                <ul class="pagination ">
                                    <li :class="(currentPageCont-1 == 0 ) ? 'disabled' : '' ">
                                    <a @click.prevent="paginationCont('prev',total_pagesCont,currentPageCont)">&laquo;</a></li>
                                    <li v-for="value in total_pagesCont" :class="(currentPageCont == value ) ? 'active' : '' "  v-if="resultSearchCounterCont > 0 && contacts && ( (value <= 10 && currentPageCont <= 10) || (currentPageCont > 10 &&  value > aux+1 && value <=currentPageCont)   )"   ><a    @click.prevent="currentPageCont=value;pageNumCont(currentPageCont,1)" v-html="value"  ></a></li>
                                    <li :class="(total_pagesCont == currentPageCont ) ? 'disabled' : '' " ><a @click.prevent="paginationCont('next',total_pagesCont,currentPageCont)"  v-if="resultSearchCounterCont>0 && contacts" >&raquo;</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Tab Noticias -->
                    <div id="empresas" class="tab-pane fade" v-if="(sectionID !='ott_summit')">
                        <div align="center">
                            <h5 class="msg" v-if="companies.length==0">No existen Empresas </h5>

                            <div class="noticia"  v-for="(tmp,key) in companies" v-if=" companies  && (typeof companies !== 'undefined' )" >
                                <div class="row">
                                    <div class="col-md-2" align="center">
                                        <div class="imagen-tab-ne-empresa" >
                                            <router-link  :to="'/empresa'+((sectionID!=='ott_vod') ? '': 'OTT')+'/'+tmp.IdCompanyFM" class="color" >
                                                <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/logos/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].Subfolder : '' )+'/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].path : '' )+')' }" ></div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="info-tabs">
                                            <router-link  :to="'/empresa'+((sectionID!=='ott_vod') ? '': 'OTT')+'/'+tmp.IdCompanyFM" class="color" >
                                                <h3 v-html="tmp.CompanyName" ></h3>
                                            </router-link>
                                            <p>Tuesday, 25 de April 2018</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Paginacion English news -->
                        <div align="center">
                            <ul class="pagination" v-if="companies.length > 0" >
                                <li :class="(currentPageComp-1 == 0 ) ? 'disabled' : '' " >
                                    <a @click.prevent="paginationComp('prev',total_pagesComp,currentPageComp)" >&laquo;</a>
                                </li>
                                <li v-for="value in (total_pagesComp)" :class="(currentPageComp == value ) ? 'active' : '' " v-if="resultSearchCounterComp>0 && companies && (value<10+currentPageComp  && value>=currentPageComp )" ><a    @click.prevent="currentPageComp=value;pageNumComp(currentPageComp)" v-html="value"></a></li>
                                <li :class="(total_pagesComp == currentPageComp ) ? 'disabled' : '' "><a @click.prevent="paginationComp('next',total_pagesComp,currentPageComp)"   v-if="resultSearchCounterComp>0 && companies"   >&raquo;</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';
    //var resfulApi="http://produbackend/admin/index.php/welcome/"

    const flowBridgeAPIBase = process.env.FLOWBRIDGE_URL;

    import axios from 'axios';

    export default {
        name: 'Content',
        data() {
            return {
                contacts: [],

                resultSearchCounterCont: 0,

                currentPageCont: 1,
                query_rowsCont: 10,
                total_pagesCont: 0,
                pageSizeCont: 10,
                pageCont: 1,

                companies: [],

                resultSearchCounterComp: 0,

                currentPageComp: 1,
                query_rowsComp: 10,
                total_pagesComp: 0,
                pageSizeComp: 10,
                pageComp: 1,

                sectionsChild: [],
                sectionID: 0,
                descripcion: '',
                categoriasOtt: [],
                catOTT: 0,
                aux: 1,
                currSectionName: '',
                defaultImage: require('@/assets/images/avatar2.png'),
                imageCache: {},
            };
        },
        created() {},
        methods: {
            moment: function() {
                return moment();
            },
            getImageUrl: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '') {
                    return this.defaultImage;
                }

                // Si ya validamos esta URL, usar el resultado del cache
                if (this.imageCache.hasOwnProperty(imageUrl)) {
                    return this.imageCache[imageUrl];
                }

                // Por defecto retornar la URL original y validar en background
                this.validateImageInBackground(imageUrl);
                return imageUrl;
            },
            validateImageInBackground: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '' || this.imageCache.hasOwnProperty(imageUrl)) {
                    return;
                }

                const img = new Image();

                img.onload = () => {
                    this.$set(this.imageCache, imageUrl, imageUrl);
                };

                img.onerror = () => {
                    // Marcar como error en cache
                    this.$set(this.imageCache, imageUrl, this.defaultImage);
                };

                img.src = imageUrl;
            },
            pageNumCont: async function(currPageIn, pressButtom = null) {
                pressButtom ? --this.aux : '';

                await axios.get(flowBridgeAPIBase + 'contacts', {
                    params: {
                        section: this.sectionID,
                        page: currPageIn,
                        limit: 10,
                        include_in_wiw: "1",
                        fields: 'featured_image,company,who'
                    }
                }).then(response => {
                    this.resultSearchCounterCont = 0;
                    this.total_pagesCont = 0;

                    const processedContacts = (response.data.data || []).map(contact => {
                        return {
                            IdContactFM: '',
                            FirstName: contact.name ? contact.name.trim() : '',
                            LastName: contact.last_name ? contact.last_name.trim() : '',
                            Title: (contact.company && contact.company.primary && contact.company.primary.position) ? contact.company.primary.position : (contact.company && contact.company.position ? contact.company.position : ''),
                            Biografia: '',
                            Images: contact.featured_image && contact.featured_image.url ? contact.featured_image.url : '',
                            IdCompanyFM: (contact.company && contact.company.primary && contact.company.primary.id) ? contact.company.primary.id : (contact.company && contact.company.id ? contact.company.id : ''),
                            CompanyName: (contact.company && contact.company.primary && contact.company.primary.name) ? contact.company.primary.name : (contact.company && contact.company.name ? contact.company.name : ''),
                            CompanyWWSection: (contact.who && contact.who.categories && contact.who.categories[0] && contact.who.categories[0].name) ? contact.who.categories[0].name : '',
                            permalink_contacto: contact.slug ? contact.slug : '',
                            permalink_empresa: contact.company && contact.company.slug ? contact.company.slug : '',
                        };
                    });
                    this.contacts = processedContacts;

                    this.resultSearchCounterCont = 0;
                    this.total_pagesCont = 0;

                    if (response.data.total > 0 && response.data.data) {
                        window.scrollTo(0, 0);

                        this.resultSearchCounterCont = response.data.total;
                        this.total_pagesCont = Math.ceil(this.resultSearchCounterCont / this.query_rowsCont);
                    }
                    this.$nextTick(function() {});
                });
            },
            getContactDataBySectionsWWFWS: async function(pageIN) {

                await axios.get(flowBridgeAPIBase + 'contacts', {
                    params: {
                        section: this.sectionID,
                        page: pageIN,
                        limit: 10,
                        include_in_wiw: true,
                        fields: 'featured_image,company,who'
                    }
                }).then(response => {
                    this.resultSearchCounterCont = 0;
                    this.total_pagesCont = 0;

                    const processedContacts = (response.data.data || []).map(contact => {
                        return {
                            IdContactFM: contact.post_id ? contact.post_id : '',
                            FirstName: contact.name ? contact.name.trim() : '',
                            LastName: contact.last_name ? contact.last_name.trim() : '',
                            Title: (contact.company && contact.company.primary && contact.company.primary.position) ? contact.company.primary.position : (contact.company && contact.company.position ? contact.company.position : ''),
                            Biografia: '',
                            Images: contact.featured_image && contact.featured_image.url ? contact.featured_image.url : '',
                            IdCompanyFM: (contact.company && contact.company.primary && contact.company.primary.id) ? contact.company.primary.id : (contact.company && contact.company.id ? contact.company.id : ''),
                            CompanyName: (contact.company && contact.company.primary && contact.company.primary.name) ? contact.company.primary.name : (contact.company && contact.company.name ? contact.company.name : ''),
                            CompanyWWSection: (contact.who && contact.who.categories && contact.who.categories[0] && contact.who.categories[0].name) ? contact.who.categories[0].name : '',
                            permalink_contacto: contact.slug ? contact.slug : '',
                            permalink_empresa: contact.company && contact.company.slug ? contact.company.slug : '',
                        };
                    });
                    this.contacts = processedContacts;

                    if (response.data.total > 0 && response.data.data) {
                        this.resultSearchCounterCont = response.data.total;
                        this.total_pagesCont = Math.ceil(this.resultSearchCounterCont / this.query_rowsCont);
                    }

                    this.$nextTick(function() {});
                });
            },

            pageNumComp: async function(currPageIn) {
                await axios
                    .post(resfulApi + 'getCompanyDataBySectionsWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        sectionID: this.sectionID,
                        page: currPageIn,
                        categoriaID: this.catOTT,
                    })
                    .then(response => {
                        this.resultSearchCounterComp = 0;
                        this.total_pagesComp = 0;
                        this.companies = response.data.result;

                        if (
                            response.data.totalRecordsComp > 0 &&
                            response.data.result
                        ) {
                            window.scrollTo(0, 0);

                            this.resultSearchCounterComp =
                                response.data.totalRecordsComp;
                            this.total_pagesComp =
                                Math.ceil(
                                    this.resultSearchCounterComp /
                                        this.query_rowsComp
                                ) - 1;

                            if (
                                (this.resultSearchCounterComp %
                                    this.query_rowsComp) %
                                this.query_rowsComp >
                                0
                            ) {
                                this.total_pagesComp = this.total_pagesComp + 1;
                            }
                        }

                        this.$nextTick(function() {});
                    });
            },
            getDataSection: async function(sectionID) {
                this.sectionID = sectionID;
                this.getContactDataBySectionsWWFWS(this.sectionID, 1);
                if (this.sectionID !== 'ott_summit')
                    this.getCompanyDataBySectionsWWFWS(1, 0);
            },
            paginationCont: async function(
                direction,
                total_pagesCont,
                currentPageCont
            ) {
                if (direction == 'prev') {
                    currentPageCont > 10 ? --this.aux : (this.aux = 0);
                    currentPageCont - 1 == 0
                        ? ''
                        : this.pageNumCont(--this.currentPageCont);
                } else {
                    currentPageCont > 10 ? ++this.aux : (this.aux = 0);
                    currentPageCont == total_pagesCont
                        ? ''
                        : this.pageNumCont(++this.currentPageCont);
                }
            },
            paginationComp: async function(
                direction,
                total_pagesComp,
                currentPageComp
            ) {
                if (direction == 'prev') {
                    currentPageComp - 1 == 0
                        ? ''
                        : this.pageNumComp(--this.currentPageComp);
                } else {
                    currentPageComp == total_pagesComp
                        ? ''
                        : this.pageNumComp(++this.currentPageComp);
                }
            },

            getCompanyOTT: async function(categoriaID) {
                $('#CategoriasOTT')
                    .removeClass('collapse in')
                    .addClass('collapse');
                this.catOTT = categoriaID;
                this.getCompanyDataBySectionsWWFWS(1, categoriaID);
            },

            getSectionsWWFWS: async function() {
                    axios
                        .post(resfulApi + 'getSectionsWWFWS', {
                            token:
                                'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        })
                        .then(
                            response => {
                                this.sections = response.data;
                                console.log('Sections cargado por getSectionsWWFWS:', this.sections);
                                this.$nextTick(function() {
                                    this.loadJqueryNavheader();
                                });
                            },
                            error => {}
                        );
            },

            // getIdUrl: async function(name) {
            //     // Esperar a que se carguen las categorías si aún no están disponibles
            //     if (!this.sections || this.sections.length === 0) {
            //         await this.getSectionsWWFWS();
            //     }

            //     // Buscar el ID por nombre en las categorías
            //     const categoria = this.sections.find(cat => cat.name === name);

            //     if (categoria) {
            //         this.sectionID = categoria.id;
            //         this.descripcion = categoria.name; // Usar el nombre como descripción
            //     }
            // },

            getIdUrl: async function(name) {
                var data = new Array();
                data['Compradores'] = 5973;
                data['Distribuidores'] = 5974;
                data['Productores'] = 5977;
                data['Dobladores'] = 5975;
                data['Ingenieros'] = 5976;
                this.sectionID = data[name];
            },
        },
        beforeMount() {},
        mounted: async function() {
            // Obtener el nombre de la sección desde el nombre de la ruta
            const sectionName = this.$route.name;
            this.currSectionName = sectionName;

            if (sectionName && ['Compradores', 'Distribuidores', 'Productores', 'Dobladores', 'Ingenieros'].includes(sectionName)) {
                // Usar getIdUrl para convertir el nombre a ID
                await this.getIdUrl(sectionName);
            } else {
                // Para rutas OTT u otras
                this.sectionID = this.$route.params.section;
            }

            // Hacer la petición con el ID correcto
            if (this.sectionID) {
                this.getContactDataBySectionsWWFWS(1);
            }
            // this.getCategoriasOTTWWFWS();

            // if (this.sectionID !== 'ott_summit')
            //     this.getCompanyDataBySectionsWWFWS(1, 0);

            // axios
            //     .post(resfulApi + 'getSectionsComponentWWFWS', {
            //         token:
            //             'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
            //     })
            //     .then(
            //         response => {
            //             this.sectionsChild = response.data;
            //             if (
            //                 this.sectionID !== 'ott_vod' &&
            //                 this.sectionID !== 'ott_summit'
            //             )
            //                 this.descripcion =
            //                     response.data[this.sectionID].Descripcion;
            //         },
            //         error => {}
            //     );
        },
        watch: {
            '$route'(newRoute, oldRoute) {
                const sectionName = newRoute.name;
                this.currSectionName = sectionName;

                if (sectionName && ['Compradores', 'Distribuidores', 'Productores', 'Dobladores', 'Ingenieros'].includes(sectionName)) {
                    // Usar getIdUrl para convertir el nombre a ID
                    this.getIdUrl(sectionName).then(() => {
                        if (this.sectionID) {
                            this.getContactDataBySectionsWWFWS(1);
                        }
                    });
                } else {
                    // Para rutas OTT u otras
                    this.sectionID = newRoute.params.section;
                    if (this.sectionID) {
                        this.getContactDataBySectionsWWFWS(1);
                    }
                }

                // if (this.sectionID !== 'ott_summit')
                //     this.getCompanyDataBySectionsWWFWS(1, 0);

                // axios
                //     .post(resfulApi + 'getSectionsComponentWWFWS', {
                //         token:
                //             'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                //     })
                //     .then(
                //         response => {
                //             this.sectionsChild = response.data;
                //             if (
                //                 this.sectionID !== 'ott_vod' &&
                //                 this.sectionID !== 'ott_summit'
                //             )
                //                 this.descripcion =
                //                     response.data[this.sectionID].Descripcion;
                //         },
                //         error => {}
                //     );
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .media-body a {
        color: #4e4e4e;
    }

    a:hover {
        cursor: pointer;
    }
    .msg {
        color: #006c8f;
    }
</style>



// WEBPACK FOOTER //
// src/components/otro/Content.vue